import React, { useState, useEffect,useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { flightTripBoardingCredential, loginCredential, seatmapTaskCredential, aisleCredential, windowCredential } from '../ReduxState';
import { checkinModule, boardingModule, monthNames, boardingTime, flightsearchPageIconsMapping } from '../Utility/CommonFun.js'
import { useHistory } from 'react-router-dom';
import ReactTooltip from "react-tooltip";
import * as moment from 'moment';
import FocusLock from "react-focus-lock";

function SubHeader(props) {
  const isFocusToSubheaderOfSeatmanagement = useSelector(state => state.login.isFocusToSubheaderOfSeatmanagement);
  const[openedPreferences,setopenedPreferences]=useState(false);
  const headerRef = useRef(null);
  const dispatch = useDispatch();
  const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
  const selectedModule = useSelector(state => state.login.Module);
  const flightManifest = useSelector(state => state.flightSearch.flightManifestBoarding);
  const flightTripBoarding = useSelector(state => state.flightSearch.flightTripBoarding);
  const seatMapTask = useSelector(state => state.flightSearch.seatmapTask);
  const aisle = useSelector(state => state.flightSearch.seatPreferenceAisle);
  const window = useSelector(state => state.flightSearch.seatPreferenceWindow);
  const selectedprintMode = useSelector(state => state.printMode.selectedMode);
  // console.log('===========', flightManifest, flightTripBoarding);
  const history = useHistory();
  const [recordlocator, setRecordLocator] = useState("");
  const [totalpax, setTotalPax] = useState(0);
  const [seatclass, setSeatClass] = useState("");
  const [segmentdetail, setSegmentDetail] = useState("");
  const [departTimeHeader, setDepartTimeHeader] = useState("");
  const [departintime, setDepartsInTime] = useState("");
  const [departTimeHeaderBoarding, setDepartTimeHeaderBoarding] = useState("");
  const [departintimeBoarding, setDepartsInTimeBoarding] = useState("");
  const [balance, setBalance] = useState(0); ///INR currencyCode
  const [showEstimatedTime, setShowEstimatedTime] = useState(false);
  const [etd, setEtd] = useState(null);
  const [eta, setEta] = useState(null);
  const [headerCardClass, setHeaderCardClass] = useState('card card-highlight headingCard mt-2');
  const [firstPax, setFirstPax] = useState('');
  const [totalSeg, setTotalSegment] = useState(0);
  const [flightStatus, setFlightStatus] = useState('');
  const [infantPnr, setInfantPnr] = useState(false);
  const [infantCount, setInfantCount] = useState(0);
  const [eltPnr, setEltPnr] = useState(false);
  const [sodPnr, setSODPnr] = useState(false);
  const [bardingSeatMapTask, setbardingSeatMapTask] = useState(seatMapTask);
  const [aisleSeat, setAisleSeat] = useState(aisle);
  const [windowSeat, setWindowSeat] = useState(window);
  useEffect(() => {
    
    var totalPax = 0;
    var totalSeg = 0;
    var vseatClass = "";
    if (SearchedFlightDetails.passenger !== undefined) {
      SearchedFlightDetails.passenger.forEach((pax) => {
        if (pax.IsSelected) {
          totalPax = totalPax + 1;
        }
      });

      let flagTimeCheck = 0;
      let departureCheck = "";
      let DepartTo = "";
      SearchedFlightDetails.journeys.forEach((val) => {
        val.segments.filter(segment => segment.IsSelected).forEach((pax, i, segs) => {
          if (pax.classOfService === 'Z' && pax.productClass === '') {
            setEltPnr(true);
          }
          if (pax.classOfService === 'Z' && pax.productClass === 'ZD') {
            setSODPnr(true);
          }
          if (pax.IsSelected) {                  
              totalSeg = totalSeg + 1;
              if (flagTimeCheck === 0) {
                flagTimeCheck = 1;
                // if (pax.legs[0].operationsInfo && (pax.legs[0].operationsInfo.departureTimes.estimated || pax.legs[0].operationsInfo.estimatedArrivalTime)) {
                if ((i === 0 && pax.legs[0].operationsInfo && pax.legs[0].operationsInfo.departureTimes.estimated)
                  ||
                  (i === segs.length -1 && pax.legs[pax.legs.length - 1].operationsInfo && pax.legs[pax.legs.length - 1].operationsInfo.estimatedArrivalTime)
                ) {
                  setShowEstimatedTime(true);
                  setEtd(moment(new Date(pax.legs[0].operationsInfo.departureTimes.estimated)).format("MMM D, YYYY HH:mm"));
                  if (i === segs.length -1 && pax.legs[pax.legs.length - 1].operationsInfo.estimatedArrivalTime) {
                    setEta(moment(new Date(pax.legs[pax.legs.length - 1].operationsInfo.estimatedArrivalTime)).format("MMM D, YYYY HH:mm"));
                  }
                  departureCheck = new Date(pax.legs[0].operationsInfo.departureTimes.estimated);
                } else {
                  departureCheck = pax.designator.departure;
                }
              }
              setFlightStatus(pax.legs[0].status === 'Normal' ? 'Open' : pax.legs[0].status); //{seg.legs[0].status === 'Normal' ? 'Open' : seg.legs[0].status}
              DepartTo = pax.designator.destination
              vseatClass = vseatClass + pax.productClass + ":" + pax.classOfService + ","
            // })           
          }
        })
      });
      setRecordLocator(SearchedFlightDetails.recordLocator);
      setBalance(SearchedFlightDetails.currencyCode + " " + SearchedFlightDetails.breakdown.balanceDue);
      if (SearchedFlightDetails.passenger !== undefined) {
        let firstPassenger = SearchedFlightDetails.passenger.find(p => p.IsSelected);
        const infantCount = SearchedFlightDetails.passenger.filter(p => p.IsSelected && p.infant);
        setInfantCount(infantCount.length);
        if (SearchedFlightDetails.passenger.some(p => p.IsSelected && p.infant !== null)) {
          setInfantPnr(true);
        }
        setFirstPax(`${firstPassenger.name.last}, ${firstPassenger.name.first} ${firstPassenger.name.title}`)
      }
// modified 101-116
// if (SearchedFlightDetails.passenger && SearchedFlightDetails.passenger.length > 0) {
//   let firstPassenger = SearchedFlightDetails.passenger.find(p => p.IsSelected);

//   if (firstPassenger) {
//     setFirstPax(`${firstPassenger.name.last}, ${firstPassenger.name.first} ${firstPassenger.name.title}`);
//   } else {
//     setFirstPax(""); // Set a default empty value to prevent issues
//   }

//   const infantCount = SearchedFlightDetails.passenger.filter(p => p.IsSelected && p.infant);
//   setInfantCount(infantCount.length);

//   if (SearchedFlightDetails.passenger.some(p => p.IsSelected && p.infant !== null)) {
//     setInfantPnr(true);
//   }
// }

      setTotalPax(totalPax);
      setTotalSegment(totalSeg);
      setSegmentDetail(totalSeg + " To " + DepartTo);
      

      var now = moment();
      var date_test = moment(departureCheck, 'YYYY-MM-DD HH:mm:ss.SSS')

      if (date_test < now) {

        const ms = moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(date_test, "DD/MM/YYYY HH:mm:ss"));
        const d = moment.duration(ms);
        const s = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");

        if (d._data.days >= 1) {
          setDepartTimeHeader('Departed')
          setDepartsInTime(d._data.days + "d " + d._data.hours + "h " + d._data.minutes + "m");
        }
        else {
          setDepartTimeHeader('Departed')
          setDepartsInTime(s);
        }
      }
      else {
        const ms = moment(date_test, "DD/MM/YYYY HH:mm:ss").diff(moment(now, "DD/MM/YYYY HH:mm:ss"));
        const d = moment.duration(ms);
        if (d._data.days > 0) {
          setDepartTimeHeader('Departs In');
          setDepartsInTime(d._data.days + "d " + d._data.hours + "h " + d._data.minutes + "m");
        }
        else {
          setDepartTimeHeader('Departs In');
          setDepartsInTime(d._data.hours + "h " + d._data.minutes + "m");
        }
      }

      setSeatClass(vseatClass.substring(0, (vseatClass.length - 1)));
    }

  }, [SearchedFlightDetails]);

  useEffect(() => {
    // debugger
    if (flightTripBoarding && selectedModule === boardingModule) {
      const now = moment();
      const { departureTimes } = flightTripBoarding.operationDetails.tripOperationTimes;
      const date_test = moment(departureTimes.estimated ? departureTimes.estimated : departureTimes.scheduled, 'YYYY-MM-DD HH:mm:ss.SSS');
      if (date_test < now) {
        const ms = moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(date_test, "DD/MM/YYYY HH:mm:ss"));
          const d = moment.duration(ms);
          const s = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");

          if (d._data.days >= 1) {
            setDepartTimeHeaderBoarding('Departed')
            setDepartsInTimeBoarding(d._data.days + "d " + d._data.hours + "h " + d._data.minutes + "m");
          }
          else {
            setDepartTimeHeaderBoarding('Departed')
            setDepartsInTimeBoarding(s);
          }
      } else {
        const ms = moment(date_test, "DD/MM/YYYY HH:mm:ss").diff(moment(now, "DD/MM/YYYY HH:mm:ss"));
          const d = moment.duration(ms);
          if (d._data.days > 0) {
            setDepartTimeHeaderBoarding('Departs In');
            setDepartsInTimeBoarding(d._data.days + "d " + d._data.hours + "h " + d._data.minutes + "m");
          }
          else {
            setDepartTimeHeaderBoarding('Departs In');
            setDepartsInTimeBoarding(d._data.hours + "h " + d._data.minutes + "m");
          }
      }
    }
  }, [flightTripBoarding, selectedModule]);

  function getSsrs(paxseg) {
    let ssrs = paxseg.ssrs.map((ssr,j) =>ssr.ssrCode+" "
    )

    if (paxseg.hasInfant) {
      ssrs = ssrs.length ? ssrs + ", INFT": 'INFT';
    }
    return ssrs.toString();
  }

  function displayPassengersSeat(pax) {
    // debugger
    let seat = '';
    SearchedFlightDetails.journeys.forEach((jou, j) => {
      const segments = jou.segments.filter(s => s.IsSelected);
      segments.forEach((seg, s) => {
        seg.passengerSegment.forEach((pseg, p) => {
          if (pseg.passengerKey === pax.passengerKey && pseg.IsSelected && pseg.seats.length > 0) {
            if (s === (segments.length - 1)) {
              seat = seat + pseg.seats[0].unitDesignator
            } else {
              seat = pseg.seats[0].unitDesignator + "," 
            }
          } 
          if (pseg.passengerKey === pax.passengerKey && pseg.IsSelected && pseg.seats.length === 0) {
            seat = seat + '--'
          }
        })
      })
    });
    return <p class="font-sm mid-dark-text mb-0">{seat}</p>
  }

  function displaySsrs(pax) {
    return SearchedFlightDetails.journeys.map((jou, j) =>
      jou.segments.map((seg, i) =>
      !seg.IsSelected ? " ":
      seg.passengerSegment.map((paxseg, k) =>
          paxseg.passengerKey === pax.passengerKey && paxseg.IsSelected ?
          <div class="ssr-content-item">
          <p class="font-sm mid-dark-text mb-0" data-tip data-for={paxseg.ssrs.length === 0 ? "" : getSsrs(paxseg)}>{" " + paxseg.ssrs.length === 0 ? "" : getSsrs(paxseg)}</p>
          <ReactTooltip id={paxseg.ssrs.length == 0 ? "" : getSsrs(paxseg)} place="top" effect="solid">
            {" " + paxseg.ssrs.length == 0 ? "" : getSsrs(paxseg)}
          </ReactTooltip>
          </div>
          :
          ""
        )
      )
    )
  }

  function openDropdown() {
    // debugger
    if (headerCardClass.indexOf('expand') === -1) {
      setHeaderCardClass('card card-highlight headingCard mt-2 expand');
    } else {
      setHeaderCardClass('card card-highlight headingCard mt-2');
    }
    
  }

  function getPhoneNumbers() {
    let numbers = '';
    if (SearchedFlightDetails.passenger !== undefined && SearchedFlightDetails.passenger.length
      && SearchedFlightDetails.contacts !== undefined && SearchedFlightDetails.contacts.phoneNumbers.length) {
        if (SearchedFlightDetails.contacts.phoneNumbers.length > 1) {
          numbers = SearchedFlightDetails.contacts.phoneNumbers[0].number + ',' + SearchedFlightDetails.contacts.phoneNumbers[1].number;
        } else {
          numbers = SearchedFlightDetails.contacts.phoneNumbers[0].number;
        }
      }
      return numbers;
  }

  const getStatusText = (status) => {
    let statusText;
    switch(status)
    {
        case 0:
            statusText = 'Boarding';
            break;
        case 1: 
            statusText = 'Closed';
            break;
        case 2: 
            statusText = 'Cancelled';
            break;
        case 3: 
            statusText = 'Suspended';
            break;
        case 5: 
            statusText = 'ClosedPending';
            break;
        case 6: 
            statusText = 'BlockAllActivities';
            break;
        case 7: 
            statusText = 'Mishap';
            break;
        default:
            statusText = '';
            break;
    }
    return statusText;
  }

  const getBoardingTime = () => {
    const date = new Date(flightManifest.departureTime);
    date.setMinutes(date.getMinutes() - boardingTime);
    return moment(date).format('HH:mm');
  }

  const handleSeatmapTask = (t) => {
    setbardingSeatMapTask(t);
    dispatch(seatmapTaskCredential(
      {
          type: "",
          seatmapTask: t,
      }
    ));
  }

  const fncSelectPreference = (e, property) => {
    const check = e.target.checked;
    switch (property) {
      case 'aisle':
        dispatch(aisleCredential(
          {
            type: '',
            seatPreferenceAisle: check
          }
        ))
        break;
      case 'window':
        dispatch(windowCredential(
          {
            type: '',
            seatPreferenceWindow: check
          }
        ))
        break
      default:
        break;
    }
  }

  const fncClearAllPreference = () => {
    dispatch(aisleCredential(
      {
        type: '',
        seatPreferenceAisle: false
      }
    ))
    dispatch(windowCredential(
      {
        type: '',
        seatPreferenceWindow: false
      }
    ))
  }

  const getPrinterStatus = (printer) => {
    // const printers = JSON.parse(localStorage.getItem('Printers'));
    let status = 'Offline';
    if (selectedprintMode === 'Native') {
      const lsPrinters = localStorage.getItem('Printers');
      if (lsPrinters !== null) {
        const printers = JSON.parse(localStorage.getItem('Printers'));
        if (printer === 'BP' && printers.boardingPass) {
          status = 'Online'; 
        }
        if (printer === 'BT' && printers.bagTag) {
          status = 'Online';
        }
      }
    } else if (selectedprintMode === 'SITA FLEX') {
      const printers = JSON.parse(localStorage.getItem('SITAPrinters'));
      // console.log('printers-------===', printers, printers.filter(p => p.deviceId.includes('ATB')))
      if (printers !== null) {
        if (printer === 'BP' && printers.filter(p => p.deviceId.includes('ATB')).length) {
          status = 'Online'; 
        }
        if (printer === 'BT' && printers.filter(p => p.deviceId.includes('BTP')).length) {
          status = 'Online';
        }
      }
    }
    
    return status
  }

  const handleFocus = (e) => {
    const button = document.getElementsByClassName("assign")[0]; // Select the first button with class "assign"
    if (!openedPreferences) {
      console.log(openedPreferences,"openedPreferences")
      setopenedPreferences(false);
        button.setAttribute("tabindex", "-1"); // Ensure it is focusable
        button.focus(); // Move focus to the button
    }    
    };
    if(openedPreferences){
      setopenedPreferences(false);
    }

    const handleKeyDownFocusForSeatManagement = (e) => {
      const taskBtn = document.getElementById('task-dropdown-btn');
      const prefBtn = document.getElementById('pref-dropdown-btn');
      const taskDropdown = taskBtn?.nextElementSibling;
      const prefDropdown = prefBtn?.nextElementSibling;
    
      const isTaskOpen = taskBtn?.getAttribute('aria-expanded') === 'true';
      const isPrefOpen = prefBtn?.getAttribute('aria-expanded') === 'true';
    
      const getFocusableElements = (parent) =>
        parent?.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
    
      const active = document.activeElement;
    
      if (e.key === "Tab") {
        const prefFocusables = getFocusableElements(prefDropdown);
        const taskFocusables = getFocusableElements(taskDropdown);
    
        const prefFirst = prefFocusables?.[0];
        const prefLast = prefFocusables?.[prefFocusables.length - 1];
    
        const taskFirst = taskFocusables?.[0];
        const taskLast = taskFocusables?.[taskFocusables.length - 1];
    
        // Trap focus within Preferences Dropdown
        if (isPrefOpen && prefDropdown?.contains(active)) {
          if (!e.shiftKey && active === prefLast) {
            e.preventDefault();
            taskBtn?.focus();
            return;
          }
    
          if (e.shiftKey && active === prefFirst) {
            e.preventDefault();
            taskBtn?.focus();
            return;
          }
        }
    
        // Trap focus within Task Dropdown
        if (isTaskOpen && taskDropdown?.contains(active)) {
          if (!e.shiftKey && active === taskLast) {
            e.preventDefault();
            prefBtn?.focus();
            return;
          }
    
          if (e.shiftKey && active === taskFirst) {
            e.preventDefault();
            prefBtn?.focus();
            return;
          }
        }
    
        // ➡️ Tab from Preferences Button (closed) to Task Button
        if (!e.shiftKey && active === prefBtn && !isPrefOpen) {
          e.preventDefault();
          taskBtn?.focus();
          return;
        }
    
        // ⬅️ Shift+Tab from Task Button (closed) to Preferences Button
        if (e.shiftKey && active === taskBtn && !isTaskOpen) {
          e.preventDefault();
          prefBtn?.focus();
          return;
        }
      }
    };
    
    
    
   
    
  return (
    selectedModule === checkinModule && SearchedFlightDetails.passenger !== undefined ?
    <div class="container-fluid" id="SubHeaderID">
      <div class={headerCardClass}>
            <a class="card-expand-btn" onClick={openDropdown}>
                <img src="newImages/icon-dropdown.svg" />
            </a>
            <div class="subHeading-content">
            <div class="seat-FDetail">
                <div class="fDetail-item">
                    <div class="fDetailsData">
                        <p data-tip data-for={`${totalpax}`} class="font-xs mid-dark-text mb-1">
                          {firstPax}  {totalpax > 1 ? `+${totalpax - 1}px` : ''} {infantCount > 0 ? ` +${infantCount}` : ''} 
                          {
                          infantPnr
                          ? <img class="infantIcon" src="newImages/infant-red.svg" />
                          : null
                          }
                          {
                            eltPnr ?
                            `**`
                            : sodPnr ?
                            `*` : null
                          }
                          </p>
                          {
                            (eltPnr || sodPnr) ?
                            <ReactTooltip id={`${totalpax}`} place="right" effect="solid">
                              {
                                eltPnr ?
                                ` (ELT PNR)`
                                : sodPnr ?
                                ` (SOD PNR)` : null
                              }
                            </ReactTooltip> : null
                          }
                          
                        <p class="semibold primary-text mb-1 font-sm">PNR- {recordlocator}</p>
                        <p class="font-xs mid-dark-text mb-1">Seg Count - {totalSeg}</p>
                    </div>
                </div>  
                <div class="fDetail-item d-flex">            
                {                 
                  SearchedFlightDetails.journeys != undefined ?
                  SearchedFlightDetails.journeys.length == 0 ? "" :
                  SearchedFlightDetails.journeys.map((jou, j) => jou.segments.map((seg, i) => seg.IsSelected == true ?                 
                    <div class="fDetailsTo me-2">
                        <div class="flightTimeLeft">
                            <p class="font-xs mid-dark-text mb-0">{moment(seg.designator.departure).format('HH:mm')}</p>
                            <p class="semibold dark-text mb-0 font-lg">{seg.designator.origin}</p>
                            <p class="font-xs mid-dark-text mb-0">{moment(seg.designator.departure).format('ddd, D MMM')}</p>
                        </div>
                        <div class="flightCenter">
                            <p class="font-xs mid-dark-text mb-1">{seg.identifier.carrierCode}{seg.identifier.identifier}</p>
                            <p class="font-xs mid-dark-text mb-1">{`${seg.legs.length -1} stops`}</p>
                            <div class="flightIcon">
                                <img src="newImages/flight-timing.svg" alt="flight" />
                            </div>
                        </div>
                        <div class="flightTimeRight">
                            <p class="font-xs mid-dark-text mb-0">{moment(seg.designator.arrival).format('HH:mm')}</p>
                            <p class="semibold dark-text mb-0 font-lg">{seg.designator.destination}</p>
                            <p class="font-xs mid-dark-text mb-0">{moment(seg.designator.arrival).format('ddd, D MMM')}</p>
                        </div>
                    </div>
                  
                  : ""
                  )
                  ) : ""                  
                }
                </div>
                    
                <div class="fDetail-item">
                    <p class="font-sm bold dark-text mb-1">{departTimeHeader}</p>
                    <p class="font-sm mid-dark-text mb-0">{departintime}</p>
                </div>
                {
                  showEstimatedTime ?
                  <div>
                    {
                      etd ?
                      <div class="fDetail-item">
                        <p class="font-sm bold dark-text mb-1">ETD</p>
                        <p class="font-sm mid-dark-text mb-0">{etd}</p>   
                      </div> : null
                    }
                    {
                      eta ?
                      <div class="fDetail-item">
                        <p class="font-sm bold dark-text mb-1">ETA</p>
                        <p class="font-sm mid-dark-text mb-0">{eta}</p>   
                      </div> : null
                    }
                  </div> : null
                }              
                <div class="fDetail-item">
                    <p class="font-sm bold dark-text mb-1">Flight Status</p>
                    <p class="font-md primary-text mb-0">{flightStatus}</p>
                </div>
                <div class="fDetail-item">
                    <p class="font-sm bold dark-text mb-1">Phone No.</p>
                    <p class="font-md primary-text mb-0">{getPhoneNumbers()}</p>
                </div>
                <div class="fDetail-item">
                    <p class="font-sm bold dark-text mb-1">Printers</p>
                    <p class="font-md primary-text mb-0">BP: {getPrinterStatus('BP') === 'Online' ? <img src="images/GreenDotOnline.svg" /> : <img src="images/RedDotOffline.svg" /> }   </p>
                    <p class="font-md primary-text mb-0">BT: {getPrinterStatus('BT') === 'Online' ? <img src="images/GreenDotOnline.svg" /> : <img src="images/RedDotOffline.svg" />} </p>
                </div>
                <div class="fDetail-item">
                    <p class="font-xl primary-text mb-1 bold">{balance}</p>
                </div>
            </div>
            <div class="seat-PDetail sub-header-passengers">
                <div class="pDetail-data me-3">
                    <div class="name-heading">
                        <p class="font-sm bold dark-text mb-0">Passenger Name</p>
                    </div>
                    <div class="seat-heading">
                        <p class="font-sm bold dark-text mb-0">Seat No.</p>
                    </div>
                    <div class="ssr-heading">
                        <p class="font-sm bold dark-text mb-0">SSR</p>
                    </div>
                </div>

                
                {SearchedFlightDetails.passenger !== undefined ?
                    SearchedFlightDetails.passenger.length == 0 ? "" :
                      SearchedFlightDetails.passenger.map((pax, paxcount) =>
                        pax.IsSelected == true ? <div class="pDetail-data">                        
                          <div class="name-content-item">
                            <p data-tip data-for={`${pax.name.first}`} class="font-sm mid-dark-text mb-0">
                              {
                                `${pax.name.last}, ${pax.name.first} ${pax.name.title}`
                              }
                            </p>
                            <ReactTooltip id={`${pax.name.first}`} place="top" effect="solid">
                              {
                                `${pax.name.last}, ${pax.name.first} ${pax.name.title}`
                              }
                            </ReactTooltip>
                            { pax.infant ?
                              <div>
                              <img class="infantIcon" data-tip data-for={`${pax.infant.name.first}${paxcount}`} src="newImages/infant-red.svg" />
                              <ReactTooltip id={`${pax.infant.name.first}${paxcount}`} place="top" effect="solid">
                              {pax.infant.name.last}, {pax.infant.name.first} {pax.infant.name.title}
                              </ReactTooltip>
                              </div>
                              : null
                            }
                          </div>
                          <div class="seat-content-item">
                                {displayPassengersSeat(pax)}
                          </div>                    
                            {displaySsrs(pax)}
                        </div>
                          : ""
                      ) : ""
                  }
            </div>
            </div>
      </div>
    </div> :
    selectedModule === boardingModule && flightManifest && flightTripBoarding ?
    <div class="full-container">
      {/* <div class="etaHeading-card  card card-highlight mt-3"> */}
    <div class="etaHeading-card card card-highlight headingCard mt-3">
            {/* <a class="card-expand-btn">
                <img src="./assets/images/icon-dropdown.svg" />
            </a> */}
            <div class="seat-FDetail boarding-FDetails">
                <div class="boarding-header-items">
                    <div class="fDetail-item boarding-icon">
                        <div class="fDetailsData">
                            <img src={flightsearchPageIconsMapping[flightTripBoarding.operationDetails.status]} alt="boarding-icon" />
                        </div>
                    </div>
                    <div class="fDetail-item flightDetails">
                        <div class="fDetailsTo">
                            <div class="flightTimeLeft">
                                <p class="font-xs mid-dark-text mb-0">
                                {moment(flightManifest.departureTime).format('HH:mm')}
                                </p>
                                <p class="semibold dark-text mb-0 font-lg">{flightTripBoarding.originDetails.station}</p>
                                <p class="font-xs mid-dark-text mb-0">
                                {("0"+new Date(flightManifest.departureTime).getDate()).slice(-2)+" "+monthNames[new Date(flightManifest.departureTime).getMonth()]}
                                </p>
                            </div>
                            <div class="flightCenter">
                                <p class="font-xs mid-dark-text mb-1">{`${flightManifest.market.identifier.carrierCode}${flightManifest.market.identifier.identifier}`}</p>
                                <div class="flightIcon">
                                    <img src="newImages/flight-timing.svg" alt="flight" />
                                </div>
                                <p class={flightTripBoarding.operationDetails.status === 0 ? "font-xs success-text mb-1" : "font-xs text-danger mb-1"}>{getStatusText(flightTripBoarding.operationDetails.status)}</p>
                            </div>
                            <div class="flightTimeRight">
                                <p class="font-xs mid-dark-text mb-0">
                                {moment(flightManifest.arrivalTime).format('HH:mm')}
                                </p>
                                <p class="semibold dark-text mb-0 font-lg">{flightTripBoarding.destinationDetails.station}</p>
                                <p class="font-xs mid-dark-text mb-0">
                                {("0"+new Date(flightManifest.departureTime).getDate()).slice(-2)+" "+monthNames[new Date(flightManifest.departureTime).getMonth()]}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="fDetail-item">
                        <p class="font-sm mid-dark-text mb-0">
                          {getBoardingTime()}
                          {/* 05: 50 boarding time B-737-800 (Y189)SGH */}
                        </p>
                    </div>
                    <div class="fDetail-item">
                        <p class="font-sm bold dark-text mb-1">{departTimeHeaderBoarding}</p>
                        <p class="font-sm mid-dark-text mb-0">
                            {departintimeBoarding}</p>
                    </div>
                    <div class="fDetail-item">
                        <p class="font-sm bold dark-text mb-1">Gate No.</p>
                        <p class="font-sm mid-dark-text mb-0">
                          {
                          flightTripBoarding.originDetails.gate.estimatedGate
                          ? flightTripBoarding.originDetails.gate.estimatedGate
                          : flightTripBoarding.originDetails.gate.actualGate
                          ? flightTripBoarding.originDetails.gate.actualGate : null
                          }
                        </p>
                    </div>
                    {
                      flightTripBoarding.operationDetails.tripOperationTimes.touchDownTimes.estimated ?
                      <div class="fDetail-item">
                        <p class="font-sm bold dark-text mb-1">ETA</p>
                        <p class="font-sm mid-dark-text mb-0">
                          {moment(flightTripBoarding.operationDetails.tripOperationTimes.touchDownTimes.estimated).format('HH:mm')}
                        </p>
                      </div> : null
                    }
                    {
                      flightTripBoarding.operationDetails.tripOperationTimes.departureTimes.estimated ?
                      <div class="fDetail-item">
                        <p class="font-sm bold dark-text mb-1">ETD</p>
                        <p class="font-sm mid-dark-text mb-0">
                          {moment(flightTripBoarding.operationDetails.tripOperationTimes.departureTimes.estimated).format('HH:mm')}
                        </p>
                      </div> : null
                    }
                </div>
                <div class="boarding-header-items">
                   
                    <div class="fDetail-item">
                        <p class="font-sm  dark-text mb-1"><span class="bold">
                        {flightManifest.cabinPassengerCounts.length && flightManifest.cabinPassengerCounts[0].manifested}</span> Sold</p>
                        <p class="font-sm dark-text mb-0"><span class="bold">
                        {flightManifest.cabinPassengerCounts.length && flightManifest.cabinPassengerCounts[0].noShow}</span> No-show</p>
                    </div>
                    <div class="fDetail-item">
                        <p class="font-sm  dark-text mb-1"><span class="bold">
                        {flightManifest.cabinPassengerCounts.length && flightManifest.cabinPassengerCounts[0].totalCheckedIn}</span> Ckd
                        </p>
                        <p class="font-sm dark-text mb-0"><span class="bold">
                          {flightManifest.cabinPassengerCounts.length && flightManifest.cabinPassengerCounts[0].totalOnBoard}</span> Brd
                        </p>
                    </div>
                    <div class="fDetail-item">
                        <p class="font-sm  dark-text mb-1"><span class="bold">{flightManifest.checkInLid}</span> Lid</p>
                        <p class="font-sm dark-text mb-0"><span class="bold">{flightManifest.checkInLid}</span> Cap</p>
                    </div>
                </div>
            </div>
            {
          history.location.pathname === '/SeatManagement' ?
          <div class="seatManagement-heading OrangeShadow" 
          //  ref={headerRef}
          // tabIndex={0} 
           >
            {/* <FocusLock disabled={isFocusToSubheaderOfSeatmanagement}> */}
            <div class="seatManagement-heading-content OrangeShadow" onKeyDown={handleKeyDownFocusForSeatManagement} >
                    <div class="task">
                        <p class="font-md mb-0">Task</p>
                        <div class="dropdown menu-btn moduleDropdown ms-3 btn-contain">
                                <button  class=" btn round-btn dropdown-toggle OrangeShadow btn-prim assign" type="button" id="task-dropdown-btn" data-bs-toggle="dropdown" aria-expanded="false" tabIndex={isFocusToSubheaderOfSeatmanagement?-1:0}>
                                    <p class="font-sm dark-text semibold mb-0">{bardingSeatMapTask === 'ASSIGNSEAT' ? 'Assign Seats': 'Block Seats'}</p>
                                </button>
                                <div class="dropdown-menu OrangeShadow" aria-labelledby="module">
                                    <ul class="menu-select-list m-0 px-0 pt-2 pb-3 OrangeShadow" >
                                        <li>
                                            <a  tabIndex={0} class={bardingSeatMapTask === 'ASSIGNSEAT' ? "select-item font-md active OrangeShadow" : "select-item font-md OrangeShadow"} 
                                            onClick={() => { handleSeatmapTask('ASSIGNSEAT') }} 
                                            onKeyDown={(event) => {
                                              if (event.key === "Enter") {
                                                  handleSeatmapTask("ASSIGNSEAT");
                                              }
                                          }}                                      
                                            > Assign Seats</a>
                                        </li>
                                        {/* <li>
                                            <a  tabIndex={0} class={bardingSeatMapTask === 'ASSIGNSEAT' ? "select-item font-md active OrangeShadow" : "select-item font-md OrangeShadow"}> Onload</a>
                                        </li> */}
                                        <li>
                                            <a tabIndex={0} class={bardingSeatMapTask === 'BLOCKSEAT' ? "select-item font-md active OrangeShadow" : "select-item font-md OrangeShadow"} 
                                            onClick={() => { handleSeatmapTask('BLOCKSEAT') }}
                                            onKeyDown={(event) => {
                                              if (event.key === "Enter") { handleSeatmapTask('BLOCKSEAT')} }}
                                              >Block Seats</a>
                                        </li>
                                    </ul>
                                </div>
                        </div>   
                    </div> 
                    <div class="seatPreferences">
                        <div class="dropdown menu-btn moduleDropdown btn-contain">
                                <button
                                //  onBlur={handleFocus} 
                                class="btn round-btn dropdown-toggle btn-prim" type="button" id="pref-dropdown-btn" 
                                onClick={()=>setopenedPreferences(true)}
                                 data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" tabIndex={isFocusToSubheaderOfSeatmanagement?-1:0}>
                                    <p class="font-sm dark-text semibold mb-0">Seat Preferences</p>
                                </button>
                                    <div class="dropdown-menu" aria-labelledby="module">
                                    <ul class="menu-select-list m-0 px-0 pt-2 pb-3">
                                        <li>
                                            <div class="font-lg">
                                                <input class="form-check-input me-2 focusClass " name="aisle" type="checkbox" id="aisle" checked={aisle} onChange={(e) => { fncSelectPreference(e, 'aisle') }} />
                                                <label class="form-check-label font-md" for="aisle">
                                                    Aisle
                                                </label>
                                            </div>
                                            
                                        </li>
                                        <li>
                                            <div class="font-lg">
                                                <input class="form-check-input me-2 focusClass" name="window" type="checkbox" id="window" checked={window} onChange={(e) => { fncSelectPreference(e, 'window') }} />
                                                <label class="form-check-label font-md" for="window">
                                                    Window
                                                </label>
                                            </div>
                                        </li>
                                        <li class="mt-4 w-100 d-flex justify-content-center">
                                            <button class="btn btn-primary SerachBtn"
                                            onClick={() => { fncClearAllPreference() }}
                                            onKeyDown={(e) => { 
                                              fncClearAllPreference(); 
                                             }} 
                                            ><span class="px-4" >Clear</span></button>
                                        </li>
                                    </ul>
                                </div>
                        </div>   
                    </div>
                </div> 
                {/* </FocusLock>   */}
            </div> : null
        }
        </div> 
        
        {/* </div> */}
      </div>: null
  );
}

export default SubHeader;
